<div class="hauteur-100">
    <kendo-drawer-container class="hauteur-88">
        <kendo-drawer
            #drawer
            mode="push"
            class="hauteur-88"
            [items]="menuService.menu()"
            [mini]="true"
            [expanded]="true"
            [autoCollapse]="false"
            [isItemExpanded]="isItemExpanded"
            (select)="onSelect($event)"
        >
        </kendo-drawer>
        <kendo-drawer-content>
            <app-my-content [selectedItem]="menuService.selectedMenuText()"></app-my-content>
        </kendo-drawer-content>
    </kendo-drawer-container>
    <div class="custom-actionbar">
        <p>Hello World avec Electron + Angular + Kendo UI.</p>
        <div class="actions">
            <button
                kendoButton
                themeColor="primary"
            >
                Archiver le prompt
            </button>
            <button
                kendoButton
                themeColor="secondary"
            >
                Lancer Ruby
            </button>
        </div>
        <br />
    </div>
</div>
